import { forwardRef, useEffect, useImperativeHandle, useState, ReactElement, Ref } from 'react';
import { Mode } from 'light-component';
import { useSignature } from './hooks';
import { CanvasImage } from './image';
import styles from './style.module.less';
import type { SignatureProps, SignatureRef } from './types';

/**
 * 以下代码拷贝自旧 web 工程的 static/javascripts/form/shoteyes-signature.js
 */
function SignatureComponent(props: SignatureProps, ref: Ref<SignatureRef>): ReactElement {
  /**
   * 初始化 canvas 和 signaturePad 组件
   */
  const { canvasRef, signatureRef } = useSignature();

  useImperativeHandle(ref, () => ({
    /**
     * 清除涂鸦区域
     */
    clear: (): void => {
      if (signatureRef.current == null || signatureRef.current.isEmpty()) {
        return;
      }
      signatureRef.current.clear();
    },

    /**
     * 保存涂鸦结果为 base64 字符串并返回
     */
    getBase64: (): string | undefined => {
      if (signatureRef.current == null || signatureRef.current.isEmpty()) {
        return;
      }

      const base64 = signatureRef.current.toDataURL();
      if (base64.length < 23) {
        return;
      }

      return base64;
    }
  }));

  /**
   * 预览模式下不显示 canvas，而用 image 显示签名图片
   */
  const [isCanvas, setCanvas] = useState(props.mode !== Mode.VIEW && props.value == null);
  useEffect(() => {
    setCanvas(props.mode !== Mode.VIEW && props.value == null);
  }, [props.mode, props.value]);

  return (
    <div className={styles.container}>
      <CanvasImage isCanvas={isCanvas} value={props.value} height={props.height} />
      <canvas
        ref={canvasRef}
        style={{ height: props.height }}
        className={isCanvas ? styles.canvas : styles.canvasInvisible}
      />
    </div>
  );
}

export const Signature = forwardRef<SignatureRef, SignatureProps>(SignatureComponent);
